import marked from 'marked'
import DOMPurify from 'dompurify'

marked.setOptions({
  breaks: true,
  gfm: true,
  headerIds: false,
  mangle: false
})

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i',
  'ul', 'ol', 'li',
  'code', 'pre',
  'a',
  'h1', 'h2', 'h3', 'h4',
  'blockquote'
]

const ALLOWED_ATTR = ['href', 'title', 'target', 'rel', 'class']

let hooked = false
if (typeof window !== 'undefined' && !hooked) {
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A') {
      node.setAttribute('target', '_blank')
      node.setAttribute('rel', 'noopener noreferrer')
      const href = node.getAttribute('href') || ''
      if (!/^(https?:|mailto:)/i.test(href)) {
        node.removeAttribute('href')
      }
    }
  })
  hooked = true
}

/**
 * Render assistant Markdown to sanitized HTML for safe v-html use.
 * User messages should stay plain text.
 */
export function renderAssistantMarkdown (text) {
  if (text == null || text === '') return ''
  const dirty = marked.parse(String(text))
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false
  })
}
